// EXPIRY DATE CALCUTOR WITH DATE FORMAT dd/mm/yyyy
export const expiryDate = (date, warrantee) => {
  const warranteePeriod = parseFloat(warrantee) * 365;
  const getWarranteeDate = new Date(date);
  getWarranteeDate.setDate(getWarranteeDate.getDate() + warranteePeriod);
  return getWarranteeDate
    .toLocaleString('en-GB', { timeZone: 'UTC' })
    .slice(0, 10);
};

// DATE FORMAT CONVERTER dd/mm/yyyy
export const convertDate = (date) => {
  const getWarranteeDate = new Date(date);
  getWarranteeDate.setDate(getWarranteeDate.getDate());
  return getWarranteeDate.toLocaleString('en-GB').slice(0, 10);
};

// DATE FORMAT CONVERTER
export const convertDateBySlices = async (date, sliceStart, sliceEnd) => {
  let t_data;
  const getNewDate = new Date(date);
  getNewDate.setDate(getNewDate.getDate());
  t_data = getNewDate.toLocaleString('en-GB').slice(sliceStart, sliceEnd);
  return t_data;
};

// DATE FORMAT CONVERTER dd/mm/yyyy HH:MM
export const converDateWithTime = (date) => {
  const getWarranteeDate = new Date(date);
  getWarranteeDate.setDate(getWarranteeDate.getDate());
  return getWarranteeDate
    .toLocaleString('en-GB', {
      timeZone: 'Africa/Johannesburg',
    })
    .slice(0, 17);
};

// CHROME DATE FORMAT CONVERTER yyyy/mm/dd hh:mm
export const converDateWithTimeForChrome = (date) => {
  const getWarranteeDate = new Date(date);
  getWarranteeDate.setDate(getWarranteeDate.getDate());
  const NewDate = getWarranteeDate.toISOString().slice(0, 10);
  const NewTime = getWarranteeDate
    .toLocaleTimeString('en-GB', {
      timeZone: 'Africa/Johannesburg',
    })
    .slice(0, 8);
  // const AM_PM = NewTime.slice(0, 2) >= 12 ? 'PM' : 'AM';
  // console.log(NewTime);
  return `${NewDate} ${NewTime}`;
};
export const convertDateForChrome = (date) => {
  const getWarranteeDate = new Date(date);
  getWarranteeDate.setDate(getWarranteeDate.getDate());
  const NewDate = getWarranteeDate.toISOString().slice(0, 10);
  const NewTime = getWarranteeDate
    .toLocaleTimeString('en-GB', {
      timeZone: 'Africa/Johannesburg',
    })
    .slice(0, 8);
  // const AM_PM = NewTime.slice(0, 2) >= 12 ? 'PM' : 'AM';
  // console.log(NewTime);
  return `${NewDate}`;
};

// TIME FORMAT CONVERTER HH:mm
export const convertToTime = (date) => {
  const getWarranteeDate = new Date(date);
  getWarranteeDate.setDate(getWarranteeDate.getDate());
  return getWarranteeDate.toLocaleString('en-GB').slice(11, 17);
};
